<div class="mt-2 small" *ngIf="case">

  <!-- Case Status -->
  <app-info-item title="Case Status"
    [data]="case.caseData.caseStatusTypeText + (case.caseData.onHold ? ' - ON HOLD' : '')">
  </app-info-item>

  <app-info-item *ngIf="case.caseData.type.id == 0" title="Other Type" [data]="case.caseData.caseTypeOther"></app-info-item>

  <!-- Client 1 -->
  <app-info-item title="Client Name" [data]="case.caseData.partyOneFirstName + ' ' + case.caseData.partyOneLastName">
    <fa-icon [icon]="getCreditCheckIcon(case.caseCreditCheckStatusClient1)" size="1x"
      [class]="getCreditCheckClass(case.caseCreditCheckStatusClient1)"
      class="clickable ms-1" (click)="editCreditSafe(1)">
    </fa-icon>
  </app-info-item>
  <app-info-item title="Client DOB" [data]="formatDate(case.caseData.partyOneDateOfBirth)"></app-info-item>

  <!-- Client 2 -->
  <ng-container *ngIf="case.caseData.partyTwoFirstName?.length > 0">
    <app-info-item title="Client 2 Name" [data]="case.caseData.partyTwoFirstName + ' ' + case.caseData.partyTwoLastName">
      <fa-icon [icon]="getCreditCheckIcon(case.caseCreditCheckStatusClient2)" size="1x"
        [class]="getCreditCheckClass(case.caseCreditCheckStatusClient2)"
        class="clickable ms-1" (click)="editCreditSafe(2)">
      </fa-icon>
    </app-info-item>
  </ng-container>

  <!-- Allocations -->
  <app-info-item title="Allocated Paralegal"
    [data]="case.caseData.allocatedToParalegalUser ? (case.caseData.allocatedToParalegalUser.firstName + ' ' + case.caseData.allocatedToParalegalUser.lastName) : 'UNALLOCATED'">
  </app-info-item>
  <app-info-item title="Allocated Admin"
    [data]="case.caseData.allocatedToAdminUser ? (case.caseData.allocatedToAdminUser.firstName + ' ' + case.caseData.allocatedToAdminUser.lastName) : 'UNALLOCATED'">
  </app-info-item>
  <app-info-item title="Authorised Signatory"
    [data]="case.caseData.authorisedSignatoryUser ? (case.caseData.authorisedSignatoryUser.firstName + ' ' + case.caseData.authorisedSignatoryUser.lastName) : ''">
    <fa-icon [icon]="faPencilAlt" size="1x" class="clickable ms-1" (click)="editAuthorisedSignatory()"></fa-icon>
  </app-info-item>

  <!-- Address -->
  <app-info-item title="Client Address">
    <div class="address-part" *ngIf="case.caseData.partyOneAddressLine1">{{case.caseData.partyOneAddressLine1}}</div>
    <div class="address-part" *ngIf="case.caseData.partyOneAddressLine2">{{case.caseData.partyOneAddressLine2}}</div>
    <div class="address-part" *ngIf="case.caseData.partyOneAddressLine3">{{case.caseData.partyOneAddressLine3}}</div>
    <div class="address-part" *ngIf="case.caseData.partyOneAddressLine4">{{case.caseData.partyOneAddressLine4}}</div>
    <div class="address-part" *ngIf="case.caseData.partyOnePostcode">{{case.caseData.partyOnePostcode}}</div>
  </app-info-item>

  <app-info-item title="Contact Number" [data]="case.caseData.partyOneContactNumberOne"></app-info-item>
  <app-info-item *ngIf="case.caseData.partyOneCorrespondenceEmail == 1" title="Email Address" [data]="case.caseData.partyOneEmailAddress"></app-info-item>

  <!-- Estate Agent / Broker -->
  <ng-container *ngIf="[1,6,7].includes(case.caseData.type.id)">
    <app-info-item
      [title]="case.caseData.type.id == 1 ? 'Broker' : 'Estate Agent'"
      [data]="case.caseData.addedByUser.firstName + ' ' + case.caseData.addedByUser.lastName">
    </app-info-item>
  </ng-container>

  <!--app-info-item title="Company"
      [data]="case.caseData.companyGroupName">
    </app-info-item-->

  <!-- Lender info (type 1 or 7) -->
  <ng-container *ngIf="case.caseData.type.id == 1 || case.caseData.type.id == 7">
    <app-info-item title="Lender"
      [data]="case.caseDetails.lender ? case.caseDetails.lender.name : case.caseDetails.otherLender">
    </app-info-item>
    <app-info-item title="Lenders Solicitor"
      [data]="case.caseDetails.lendersSolicitorId > 0 ? case.caseDetails.lendersSolicitor.name : case.caseDetails.otherLendersSolicitor">
    </app-info-item>
    <app-info-item title="Lenders Solicitor Email"
      [data]="case.caseDetails.lendersSolicitorEmailId > 0 ? case.caseDetails.lendersSolicitorEmail.emailAddress : case.caseDetails.otherLendersSolicitorEmail">
    </app-info-item>
    <app-info-item title="Lenders Solicitor Reference" [data]="case.caseDetails.lendersSolicitorReference"></app-info-item>
    <app-info-item title="Consultant" [data]="case.caseDetails.externalConsultant?.name"></app-info-item>
    <app-info-item title="Consultant Phone" [data]="case.caseDetails.externalConsultant?.phoneNumber"></app-info-item>
  </ng-container>

  <!-- Correspondence Options -->
  <div class="mt-2">
    <strong>Client Correspondence Options</strong>
    <table class="table table-sm table-borderless mb-0 small mt-1">
      <tr>
        <td class="fw-semibold" style="width: 120px;">Post</td>
        <td>
          <span style="width: 28px; display: inline-block;" class="py-0">{{yesNo(case.caseData.partyOneCorrespondenceLetter)}}</span>
          <ng-container *ngTemplateOutlet="yesNoIcon; context: { value: case.caseData.partyOneCorrespondenceLetter }"></ng-container>
        </td>
      </tr>
      <tr>
        <td class="fw-semibold">Email</td>
        <td>
          <span style="width: 28px; display: inline-block;" class="py-0">{{yesNo(case.caseData.partyOneCorrespondenceEmail)}}</span>
          <ng-container *ngTemplateOutlet="yesNoIcon; context: { value: case.caseData.partyOneCorrespondenceEmail }"></ng-container>
        </td>
      </tr>
      <tr>
        <td class="fw-semibold">Text Message</td>
        <td>
          <span style="width: 28px; display: inline-block;" class="py-0">{{yesNo(case.caseData.partyOneCorrespondenceSMS)}}</span>
          <ng-container *ngTemplateOutlet="yesNoIcon; context: { value: case.caseData.partyOneCorrespondenceSMS }"></ng-container>
        </td>
      </tr>
    </table>
  </div>

  <ng-template #yesNoIcon let-value="value">
    <fa-icon *ngIf="value === true" [icon]="faCheckCircle" class="text-success"></fa-icon>
    <fa-icon *ngIf="value === false" [icon]="faTimesCircle" class="text-danger"></fa-icon>
    <fa-icon *ngIf="value === null || value === undefined" [icon]="faQuestionCircle" class="text-muted"></fa-icon>
</ng-template>

  <app-linked-cases 
        [caseId]="caseId">
  </app-linked-cases>


</div>